<template>
    <div class="mainNav">
        <div class="fsToggle"><div @click="fullscreen" class="btn"></div></div>   
    </div>
</template>

<script>

export default {
    name: 'MainNav',
    props: {},
    mixins: [],
    data() {
        return {
            fs: false
        }
    },

    components: {
    },

    methods: {
        fullscreen() {
            console.log("FS");
            var doc = window.document;
            var docEl = doc.documentElement;

            var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
            var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

            if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                requestFullScreen.call(docEl);
            }
            else {
                cancelFullScreen.call(doc);
            }
        }
    },

    computed: {
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
    }

}
</script>

<style lang="scss">
.mainNav {
    position: absolute;
    right: 10px;
    height: 10vw;
    top: 0;
    z-index: 1000;
    .fsToggle {
        position: fixed;
        top: 0;
        width: 100vw;
        left: 0;
        right: 0;
        height: 10vw;
        text-align: center;
        .btn {
            display: inline-block;
            height: 5vw;
            width: 10vw;
        }
    }
}
</style>